<!-- 
HACCP情報画面の日時情報ピッカー
@slot
  prefix : 日時情報ピッカーの左側に表示するコンテンツ
-->

<template>
  <div>
    <v-row align="center" class="pa-2">
      <v-col cols="12" sm="12" md="6" lg="5" xl="4">
        <v-row align="center">
          <v-col>
            <v-btn color="primary" outlined @click.stop="backToHome"
              ><v-icon class="mr-2">mdi-arrow-left</v-icon>一覧へ</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-col style="white-space: nowrap" cols="auto" class="mr-2">
            <slot name="prefix"></slot>
          </v-col>
        </v-row>
      </v-col>
      <v-col style="text-align: center" cols="12" sm="12" md="6" lg="4" xl="4">
        <v-btn
          text
          v-show="!showDatePicker"
          :disabled="!allowBackDate"
          @click="previousDate"
        >
          <v-icon>mdi-menu-left</v-icon>
        </v-btn>
        <v-btn
          text
          @click="showDatePicker = !showDatePicker"
          :disabled="showDatePicker"
          >{{ localizedDate }}</v-btn
        >
        <v-btn
          text
          v-show="!showDatePicker"
          :disabled="!allowNextDate"
          @click="nextDate"
        >
          <v-icon>mdi-menu-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-show="showDatePicker" class="mb-4">
      <v-col cols="0" sm="0" md="6" lg="5" xl="4"> </v-col>
      <v-col cols="12" sm="12" md="6" lg="4" xl="4" style="text-align: center">
        <v-date-picker
          locale="jp"
          v-model="date"
          elevation="12"
          :width="400"
          :day-format="pickupDate"
          :max="dateRange.max"
          :events="eventsRef"
          :picker-date.sync="pickerDate"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="datePickerClose"
            >キャンセル</v-btn
          >
          <v-btn text color="primary" @click="datePickerApply">OK</v-btn>
        </v-date-picker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  computed: {
    /**
     * 検索対象日を表示日時に変換して返す
     */
    localizedDate() {
      return new DateWrapper(this.searchDate).format.localizedDate;
    },
    /**
     * 翌日に移動できるのならtrueを返す
     */
    allowNextDate() {
      if (
        new DateWrapper(this.searchDate)
          .appendDay(1)
          .compare(this.dateRange.max) >= 1
      ) {
        return false;
      }
      return true;
    },
    /**
     * 前日に移動できるのならtrueを返す
     */
    allowBackDate() {
      return true;
    },
  },
  props: ["events"],
  data() {
    const now = new DateWrapper(Date.now()).format;
    return {
      showDatePicker: false,
      date: now.systemDate,
      searchDate: now.systemDate,
      pickerDate: null,
      dateRange: {
        max: now.systemDate,
      },
      eventsRef: this.eventsFormat,
    };
  },
  watch: {
    /**
     * カレンダーの表示月が変更されたのであれば、月間イベントを再取得する
     */
    pickerDate(newval, oldval) {
      const newDate = new DateWrapper(newval);
      const oldDate = new DateWrapper(oldval);
      let updated = false;
      if (newDate.isValid && oldDate.isValid) {
        if (newDate.format.systemDate != oldDate.format.systemDate) {
          updated = true;
        }
      } else if (newDate.isValid) {
        updated = true;
      }
      if (updated) {
        this.$emit("on-update-calendar-month", newDate);
      }
    },
    /**
     * カレンダーの月間イベントを更新する
     */
    events() {
      this.eventsRef = null;
      this.eventsRef = this.eventsFormat;
    },
  },
  methods: {
    /**
     * 検索対象日を更新する
     */
    updateSearchDate(newSearchDate) {
      if (this.searchDate != newSearchDate) {
        this.searchDate = newSearchDate;
        this.date = newSearchDate;
        this.$emit("on-update-search-date", this.searchDate);
      }
    },
    /**
     * 戻るボタンが押下された
     */
    backToHome() {
      this.$router.push("/product");
    },
    /**
     * カレンダーピッカーを閉じる
     */
    datePickerClose() {
      const cancelled = this.parseDateInfo(this.searchDate, 0);
      this.date = cancelled.date;
      this.pickerDate = cancelled.month;
      this.showDatePicker = false;
    },
    /**
     * カレンダーピッカーの選択日時を検索対象日に反映する
     */
    datePickerApply() {
      this.updateSearchDate(this.date);
      this.datePickerClose();
    },
    /**
     * 日時文字列をオフセット日だけずらして返却する
     */
    parseDateInfo(dateString, offsetDays) {
      const currentDate = new DateWrapper(dateString).appendDay(offsetDays);
      const currentMonth = currentDate.format.build(
        (d) => `${d.date.y}-${d.date.m}`
      );
      return {
        month: currentMonth,
        date: currentDate.format.systemDate,
      };
    },
    /**
     * 翌日に移動する
     */
    nextDate() {
      const today = this.parseDateInfo(this.searchDate, 0);
      const next = this.parseDateInfo(this.searchDate, 1);
      this.updateSearchDate(next.date);
      if (today.month != next.month) {
        this.pickerDate = next.month;
      }
    },
    /**
     * 前日に移動する
     */
    previousDate() {
      const today = this.parseDateInfo(this.searchDate, 0);
      const previous = this.parseDateInfo(this.searchDate, -1);
      this.updateSearchDate(previous.date);
      if (today.month != previous.month) {
        this.pickerDate = previous.month;
      }
    },
    /**
     * 対象日から日を取得する
     */
    pickupDate(date_string) {
      return new DateWrapper(date_string).format.build((d) => `${d.date.d}`);
    },
    /**
     * カレンダー上にイベントを表示する
     */
    eventsFormat(dateString) {
      const date = new DateWrapper(dateString).format.systemDate;
      return [
        {
          // 作業記録
          target: this.events.worklog,
          color: "orange",
        },
        {
          // 出荷
          target: this.events.shipping,
          color: "green",
        },
        {
          // 水揚げ
          target: this.events.unloading,
          color: "red",
        },
        {
          // 使用海水
          target: this.events.seawater,
          color: "blue",
        },
      ].map((item) => {
        if (item.target && item.target.some((item) => item == date)) {
          return item.color;
        }
        // イベントがないものは背景色を透明にして表示する
        // 4つの点が並んだ時に、点の位置と色で分かるよう配慮するため
        return "no-background-color";
      });
    },
  },
};
</script>

<!--DatePickerのスタイルを継承して書き換え、2つ目で改行するようにする -->
<style>
.v-date-picker-table th {
  background-color: #ffffff !important;
}

.v-date-picker-table__events {
  max-width: 20px !important;
  left: 6px !important;
  top: 24px !important;
}

.v-date-picker-table--date div {
  float: left !important;
  margin-bottom: 1px !important;
  margin-left: 1px !important;
  margin-right: 0px !important;
  margin-top: 0px !important;
}

.no-background-color {
  background-color: transparent !important;
  border-color: transparent !important;
}
</style>
